module.exports = "images/our-secret-sauce_poster@3x.jpg";